module.exports = __webpack_public_path__ + "img/aq.164cfa9a.svg";